import axios from 'axios'
import { HEADER, TOKENIDENTITY } from '../constants'
import { URL, LOCAL } from '../config'

export default class Location {
  static INSTANCE = new Location();

  listProvince = [
    {
      idProvince: 1,
      province: 'Álava'
    },
    {
      idProvince: 37,
      province: 'Burgos'
    }
  ];

  listPopulation = [
    {
      idPopulation: 1016,
      idProvince: 1,
      population: 'Bernedo'
    },
    {
      idPopulation: 9109,
      idProvince: 37,
      population: 'Condado de Treviño'
    },
    {
      idPopulation: 1030,
      idProvince: 1,
      population: 'Lagrán'
    }
  ];

  Location() {}

  getListProvince = async (token, cp) => {
    if (!LOCAL) {
      let url = `${URL()}/CvProvincias/${cp}`
      if (token) {
        return await axios.get(url, HEADER(token)).then(response => {
          const parseResponse = response.data.map(item => {
            return {
              idProvince: item.iProvincia,
              province: item.provincia
            }
          })
          this.listProvince = parseResponse
          return this.listProvince
        })
      } else {
        return TOKENIDENTITY().then(headerWithToken => {
          return axios
            .get(url, headerWithToken).then(response => {
              const parseResponse = response.data.map(item => {
                return {
                  idProvince: item.iProvincia,
                  province: item.provincia
                }
              })
              this.listProvince = parseResponse
              return this.listProvince
            })
        })
      }
    } else {
      return this.listProvince
    }
  };

  getListPopulation = async (token, cp, idProvince) => {
    if (!LOCAL) {
      let url = `${URL()}/CvMunicipios/${cp}`
      if (idProvince) {
        return this.listPopulation.filter(
          population => population.idProvince === idProvince
        )
      } else {
        if (token) {
          return await axios.get(url, HEADER(token)).then(response => {
            const parseResponse = response.data.map(item => {
              return {
                idPopulation: item.iMunicipio,
                idProvince: item.iProvincia,
                population: item.municipio
              }
            })
            this.listPopulation = parseResponse
            return this.listPopulation
          })
        } else {
          return TOKENIDENTITY().then(headerWithToken => {
            return axios
              .get(url, headerWithToken).then(response => {
                const parseResponse = response.data.map(item => {
                  return {
                    idPopulation: item.iMunicipio,
                    idProvince: item.iProvincia,
                    population: item.municipio
                  }
                })
                this.listPopulation = parseResponse
                return this.listPopulation
              })
          })
        }
      }
    } else {
      return this.listPopulation
    }
  };
}
